<template>
  <b-overlay :show="flagBusy">
    <portlet title="تىل سەھىپە تەھرىرلەش">
      <template v-slot:body>
        <flag-form
          ref="flag"
          action="edit"
          :model-id="flagId"
          @loading="onLoading"
          @loaded="onLoaded"
          @updating="onLoading"
          @updated="onUpdated"
        />
      </template>
      <template v-slot:foot>
        <b-button id="submit" @click="handleSubmit" variant="primary">
          ساقلاش
        </b-button>
        <b-button class="ml-2" variant="danger" @click="onClickReset">
          بىكار قىلىش
        </b-button>
      </template>
    </portlet>
  </b-overlay>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import FlagForm from "@v@/components/forms/FlagForm";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import sweetAlertMixin from "@m@/common/sweetAlert.mixin";
  import { debugConsole } from "@c@/helpers/helpers";
  export default {
    name: "index",
    components: { Portlet, FlagForm },
    mixins: [ formBusyMixin, sweetAlertMixin ],
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'سەھىپە باشقۇرۇش', route: {name: 'flag.home'}});
      BreadCrumbs.addBreadCrumb({title: 'سەھىپە ئۇچۇرى تەھرىرلەش'});
      if ( this.$refs.hasOwnProperty('flag') ){
        this.form = this.$refs['flag'];
      }
    },
    computed: {
      flagId(){
        if ( this.$route.hasOwnProperty('params') )
          return this.$route.params.id;
      },
    },
    data(){
      return {
        flagBusy: false,
        form: {}
      };
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onLoading(){
        this.showBusy('flagBusy');
        debugConsole({prefix: 'flag', message: 'onLoading'})
      },
      onLoaded({response, state}){
        this.hideBusy('flagBusy');
        debugConsole({prefix: 'flag', message: `onLoaded: ${state}`});
      },
      onUpdated({response, state}){
        this.hideBusy('flagBusy');
        debugConsole({prefix: 'flag', message: `onUpdated: ${state}`});
        if ( state === 'success' ){
          this.success({ message: 'سەھىپە ئۇچۇرى تەھرىرلەش مۇۋاپىقىيەتلىك بولدى.' });
        }
      },
      onClickReset(){
        this.$router.replace({name: 'flag.home'});
      },
    }
  }
</script>

<style scoped>

</style>
